import { differenceInDays } from "date-fns";
import is from "is";
import { nanoid } from "nanoid";
import store from "../stores/StoreRoot";
import { isSameText, formatDateTimeWithFormat } from "./helper";

export function getJsDateFromExcel(excelDate) {
  if (excelDate) {
    return new Date((excelDate - (25567 + 2)) * 86400 * 1000);
  } else {
    return undefined;
  }
}

export function getExcelDateFromJsDate(jsDate, withTime) {
  const startDate = new Date(1900, 0, 0);
  const diffDays = differenceInDays(jsDate, startDate) + 1;
  if (!withTime) return diffDays;
  // calculate time fraction
  const hours = jsDate.getHours();
  const minutes = jsDate.getMinutes();
  const seconds = jsDate.getSeconds();
  const timeSeconds = seconds + minutes * 60 + hours * 60 * 60;
  const fullSeconds = 86400;
  const fraction = timeSeconds / fullSeconds;
  const fractionString = String(fraction).substr(0, 12); // max fraction = 10
  const result = diffDays + parseFloat(fractionString);

  return result;
}

export function ExcelDateToJSDate(serial) {
  var utc_days = Math.floor(serial - 25569);
  var utc_value = utc_days * 86400;
  var date_info = new Date(utc_value * 1000);

  var fractional_day = serial - Math.floor(serial) + 0.0000001;

  var total_seconds = Math.floor(86400 * fractional_day);

  var seconds = total_seconds % 60;

  total_seconds -= seconds;

  var hours = Math.floor(total_seconds / (60 * 60));
  var minutes = Math.floor(total_seconds / 60) % 60;

  return new Date(
    date_info.getFullYear(),
    date_info.getMonth(),
    date_info.getDate(),
    hours,
    minutes,
    seconds,
  );
}

export function ExcelDateToFormatedString(serial, date_format) {
  let isDate = is.date(serial);

  let date = isDate ? serial : ExcelDateToJSDate(serial);
  if (!date) return serial;

  let formatedDate = formatDateTimeWithFormat(date, date_format);
  return formatedDate;
}

// export function getDateFromExcel(excelDate) {
//   if (excelDate) {
//     return new Date(excelDate);
//   } else {
//     return undefined;
//   }
// }

// export function getDateFromGermanExcel(excelDate) {
//   if (isValidDate(excelDate)) {
//     return excelDate;
//   } else {
//     return getJsDateFromExcel(excelDate);
//     // var dateParts = excelDate.split(".");
//     // // month is 0-based, that's why we need dataParts[1] - 1
//     // return new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
//   }
// }

// names

export function getSheetNameFromAddress(address) {
  if (!address) {
    return "";
  }
  const sheetNameSeparatorIndex = is.string(address)
    ? address.indexOf("!")
    : -1;
  let sheetName =
    sheetNameSeparatorIndex > -1
      ? address.substring(0, sheetNameSeparatorIndex)
      : "";
  // add surroundings if needed
  if (sheetName.includes(" ") && !sheetName.includes("'")) {
    sheetName = "'" + sheetName + "'";
  }
  return sheetName;
}

export function getSheetNameFromAddressForUrl(address) {
  let name = getSheetNameFromAddress(address);
  return name.replaceAll("'", "");
}

// export function getSafeWorksheetName(address) {
//   if (!address) {
//     return "";
//   }
//   const sheetNameSeparatorIndex = is.string(address)
//     ? address.indexOf("!")
//     : -1;
//   let sheetName =
//     sheetNameSeparatorIndex > -1
//       ? address.substring(0, sheetNameSeparatorIndex)
//       : "";
//   // add surroundings if needed
//   if (sheetName.includes(" ") && !sheetName.includes("'")) {
//     sheetName = "'" + sheetName + "'";
//   }
//   return sheetName.toLowerCase();
// }

export function getLocalCellNameFromAddress(address) {
  if (!address) return "";

  const sheetNameSeparatorIndex = address.indexOf("!");
  const cellAddress =
    sheetNameSeparatorIndex > -1
      ? address.substring(sheetNameSeparatorIndex + 1)
      : "";
  return cellAddress;
}

export function getLocalCellNameFromAddressNoDollar(address) {
  return getLocalCellNameFromAddress(address).replaceAll("$", "");
}

// export function getLocalCellNamesFromRange(address) {
//   if (!address) return "";

//   const sheetNameSeparatorIndex = address.indexOf("!");
//   const cellAddress =
//     sheetNameSeparatorIndex > -1
//       ? address.substring(sheetNameSeparatorIndex + 1)
//       : "";
//   const cellSeparatorIndex = cellAddress.indexOf(":");
//   if (cellSeparatorIndex === -1) return null;

//   const leftCellAddress = cellAddress.substring(0, cellSeparatorIndex);
//   const rightCellAddress = cellAddress.substring(cellSeparatorIndex + 1);

//   return { left: leftCellAddress, right: rightCellAddress };
// }

export function getFirstCellFromRange(address) {
  if (!address) return "";

  const sheetNameSeparatorIndex = address.indexOf("!");
  const cellAddress =
    sheetNameSeparatorIndex > -1
      ? address.substring(sheetNameSeparatorIndex + 1)
      : "";
  const cellSeparatorIndex = cellAddress.indexOf(":");
  if (cellSeparatorIndex === -1) return address;

  const rightCellAddress = cellAddress.substring(cellSeparatorIndex + 1);
  let newAddress = address.replace(":" + rightCellAddress, "");

  return newAddress;
}

export function getIsSingleCellFromAddress(address) {
  if (!address) {
    return false;
  }
  const sheetNameSeparatorIndex = address.indexOf("!");
  const cellAddress =
    sheetNameSeparatorIndex > -1
      ? address.substring(sheetNameSeparatorIndex + 1)
      : "";
  const cellSeparatorIndex = cellAddress.indexOf(":");
  if (cellSeparatorIndex === -1) {
    return true;
  }

  const leftCell = cellAddress.substring(0, cellSeparatorIndex);
  const rightCell = cellAddress.substring(cellSeparatorIndex + 1);
  return leftCell === rightCell;
}

export function getOptimizedCellAddress(address) {
  if (!address || !is.string(address)) return "";
  let newAddress = address.replaceAll("$", "");
  const isSingleCell = getIsSingleCellFromAddress(newAddress);
  if (!isSingleCell) return newAddress;

  const sheetNameSeparatorIndex = newAddress.indexOf("!");
  const cellAddress =
    sheetNameSeparatorIndex > -1
      ? newAddress.substring(sheetNameSeparatorIndex + 1)
      : "";
  const cellSeparatorIndex = cellAddress.indexOf(":");
  if (cellSeparatorIndex === -1) {
    return newAddress;
  }

  const rightCell = cellAddress.substring(cellSeparatorIndex + 1);
  newAddress = newAddress.replace(":" + rightCell, "");
  return newAddress;
}

export function getNamesForWorksheet(
  workbookNames,
  workSheetName,
  workSheetOffset,
) {
  let names = [];
  let colorIndex = 0;
  workbookNames.forEach((bookName) => {
    let isOK = is.string(bookName.value) && bookName.value.includes("!");
    if (isOK) {
      let sheetName =
        bookName.value.substr(0, bookName.value.indexOf("!")) ?? "";
      // sheetName = sheetName.replaceAll("'", "");
      // is it really the same text
      isOK = isSameText(sheetName, workSheetName);
    }

    if (isOK) {
      const cellAddress = bookName.value
        .replace(workSheetName + "!", "")
        .replaceAll("$", "");
      let fromCellAddress = cellAddress;
      let toCellAddress = "";
      const separatorIndex = cellAddress.indexOf(":");
      if (separatorIndex > -1) {
        fromCellAddress = cellAddress.substring(0, separatorIndex);
        toCellAddress = cellAddress.substring(separatorIndex + 1);
      }
      // FROM
      let fromCellInfo = undefined;
      if (fromCellAddress.length > 0) {
        fromCellInfo = getCartesianCoords(fromCellAddress);
        fromCellInfo.row = fromCellInfo.row - workSheetOffset.row - 1;
        fromCellInfo.col = fromCellInfo.col - workSheetOffset.col - 1;
      }
      // TO
      let toCellInfo = undefined;
      if (toCellAddress.length > 0) {
        toCellInfo = getCartesianCoords(toCellAddress);
        // add the offset
        toCellInfo.row = toCellInfo.row - workSheetOffset.row - 1;
        toCellInfo.col = toCellInfo.col - workSheetOffset.col - 1;
      }
      // single cell ranges
      if (toCellInfo === undefined) {
        toCellInfo = { ...fromCellInfo };
      }
      names.push({
        id: bookName.id,
        name: bookName.name,
        value: bookName.value,
        row: fromCellInfo.row,
        col: fromCellInfo.col,
        fromCell: fromCellInfo,
        toCell: toCellInfo,
        type: "range",
        backgroundColor: store.colors.colorPalette[colorIndex],
      });
      colorIndex =
        colorIndex < store.colors.colorPalette.length ? colorIndex + 1 : 0;
    }
  });
  return names;
}

// COORDINATES

export function getRangeAddress(row, col, row2, col2, sheetName, rangeOffset) {
  let calcRow1 = row;
  let calcCol1 = col;
  let calcRow2 = row2;
  let calcCol2 = col2;
  let name = sheetName ?? "";
  if ((name.includes(" ") || name.includes("&")) && !name.includes("'")) {
    name = "'" + name + "'";
  }

  if (calcCol1 > calcCol2) {
    calcCol1 = col2;
    calcCol2 = col;
    calcRow1 = row2;
    calcRow2 = row;
  }
  const leftCoord = getExcelCoords(
    calcRow1 + rangeOffset.row + 1,
    calcCol1 + rangeOffset.col + 1,
  );
  const rightCoord = getExcelCoords(
    calcRow2 + rangeOffset.row + 1,
    calcCol2 + rangeOffset.col + 1,
  );
  let tempAddress = name + "!" + leftCoord;
  if (leftCoord !== rightCoord) {
    tempAddress = tempAddress + ":" + rightCoord;
  }

  return tempAddress;
}

export function getRangeStartOffset(address) {
  if (!address) return;

  const sheetNameSeparatorIndex = address.indexOf("!");
  const sheetName =
    sheetNameSeparatorIndex > -1
      ? address.substring(0, sheetNameSeparatorIndex)
      : "";
  // calculate offset
  const offsetAddress = address.replace(sheetName + "!", "");
  const offsetFrom = offsetAddress.substring(0, offsetAddress.indexOf(":"));
  let offset = getCartesianCoords(offsetFrom);
  offset.col = offset.col - 1;
  offset.row = offset.row - 1;
  return { row: offset.row, col: offset.col };
}

// export function getAddressWithOffset(address, rowOffset, colOffset) {
//   if (!address) return;

//   const [sheetName, range] = address.split("!");
//   const [offsetAddress] = range.split(":");
//   const offset = getCartesianCoords(offsetAddress);
//   offset.col = offset.col + colOffset;
//   offset.row = offset.row + rowOffset;

//   return `${sheetName}!${getExcelCoords(offset.row, offset.col)}`;
// }

const getRange = (from, to) =>
  Array.from({ length: to - from }, (k, v) => v + from);

export function getDataGridFromRange(
  dataTable,
  rowFrom,
  colFrom,
  rowTo,
  colTo,
) {
  if (!dataTable) return;
  let reducedData = [];
  let namedStyles = [];

  try {
    const rows = getRange(rowFrom, rowTo);

    for (let row = 0; row < rowTo; row++) {
      if (rows.includes(row)) {
        const rowData = dataTable[row];
        if (rowData) {
          Object.keys(rowData).forEach((col) => {
            if (col > colTo || col < colFrom - 1) {
              delete rowData[col];
            } else {
              const style = rowData[col].style;
              if (style) namedStyles.push(style);
            }
          });
          reducedData.push(rowData);
        } else {
          reducedData.push({});
        }
      } else {
        reducedData.push({});
      }
    }
  } catch (error) {
    console.log("ERROR getDataGridFromRange", error);
  }
  let uniqueStyles = [...new Set(namedStyles)];
  return { dataTable: reducedData, uniqueStyles: uniqueStyles };
}

export function getDataTableFromRange(
  dataTable,
  rowFrom,
  colFrom,
  rowTo,
  colTo,
) {
  const rows = getRange(rowFrom, rowTo);
  const columns = getRange(colFrom, colTo);

  let data;
  try {
    data = rows.reduce((acc, row) => {
      acc[row] = columns.reduce((rowAcc, column) => {
        rowAcc[column] = dataTable[row][column];
        return rowAcc;
      }, {});
      return acc;
    }, {});
  } catch (err) {
    console.error(err);
  }

  return data;
}

// export function getUniqueNamedStylesForRange(sheet, offset) {
//   // get only the data that is selected = reduced dataTable
//   let dataTable = getDataTableFromRange(
//     sheet.data.dataTable,
//     offset.rowFrom,
//     offset.colFrom,
//     offset.rowTo + 1,
//     offset.colTo + 1
//   );
//   // optimize the used styles
//   if (!dataTable) return [];

//   let tempStyles = Object.values(dataTable)
//     .map(Object.values)
//     .flat()
//     .map((a) => a?.style);
//   let uniqueStyles = [...new Set(tempStyles)];
//   return uniqueStyles;
// }

// getDataRangesForCharts(charts) {
//   if (!charts) return [];
//   let ranges = [];

//   charts.forEach((chart) => {
//     let chartGroups = chart.chartSpace?.chart?.plotArea?.chartGroups;
//     if (chartGroups) {
//       chartGroups.forEach((chartGroup) => {
//         let series = chartGroup.ser ?? [];
//         series.forEach((serie, index) => {
//           let val = serie.val?.numRef?.f ?? "";
//           if (val) {
//             let isOK = !val.includes(",");

//             if (isOK === true) {
//               ranges.push({
//                 type: "chart",
//                 subType: "values",
//                 serie: index,
//                 name: chart.name,
//                 range: val.replaceAll("$", ""),
//               });
//             } else {
//               let combiString = val.replaceAll("(", "").replaceAll(")", "");
//               let vals = combiString.split(",");

//               vals.forEach((valItem) =>
//                 ranges.push({
//                   type: "chart",
//                   subType: "values",
//                   serie: index,
//                   name: chart.name,
//                   range: valItem.replaceAll("$", ""),
//                 }),
//               );
//             }
//           }
//           // let cat = serie.cat?.numRef?.f ?? "";
//           // if (cat)
//           //   ranges.push({
//           //     type: "chart",
//           //     subType: "category",
//           //     serie: index,
//           //     name: chart.name,
//           //     range: cat.replaceAll("$", ""),
//           //   });
//           // let tx = serie.tx?.strRef?.f ?? "";
//           // if (tx)
//           //   ranges.push({
//           //     type: "chart",
//           //     subType: "text",
//           //     serie: index,
//           //     name: chart.name,
//           //     range: tx.replaceAll("$", ""),
//           //   });
//         });
//       });
//     }
//   });
//   return ranges;
// }

// export function getDataRangesForCharts(charts) {
//   if (!charts) return [];
//   let ranges = [];

//   charts.forEach((chart) => {
//     let chartGroups = chart.chartSpace?.chart?.plotArea?.chartGroups;
//     if (chartGroups) {
//       chartGroups.forEach((chartGroup) => {
//         let series = chartGroup.ser ?? [];
//         series.forEach((serie, index) => {
//           let val = serie.val?.numRef?.f ?? "";
//           if (val) {
//             let isOK = !val.includes(",");

//             if (isOK === true) {
//               ranges.push({
//                 type: "chart",
//                 subType: "values",
//                 serie: index,
//                 name: chart.name,
//                 range: val.replaceAll("$", ""),
//               });
//             } else {
//               let combiString = val.replaceAll("(", "").replaceAll(")", "");
//               let vals = combiString.split(",");

//               vals.forEach((valItem) =>
//                 ranges.push({
//                   type: "chart",
//                   subType: "values",
//                   serie: index,
//                   name: chart.name,
//                   range: valItem.replaceAll("$", ""),
//                 })
//               );
//             }
//           }
//           // let cat = serie.cat?.numRef?.f ?? "";
//           // if (cat)
//           //   ranges.push({
//           //     type: "chart",
//           //     subType: "category",
//           //     serie: index,
//           //     name: chart.name,
//           //     range: cat.replaceAll("$", ""),
//           //   });
//           // let tx = serie.tx?.strRef?.f ?? "";
//           // if (tx)
//           //   ranges.push({
//           //     type: "chart",
//           //     subType: "text",
//           //     serie: index,
//           //     name: chart.name,
//           //     range: tx.replaceAll("$", ""),
//           //   });
//         });
//       });
//     }
//   });
//   return ranges;
// }

// export function getDataRangesForDropdowns(validations, sheetName) {
//   if (!validations) return [];
//   let ranges = [];

//   validations.forEach((validation) => {
//     if (validation?.inCellDropdown) {
//       let validatorInfo = validation.validatorInfo;
//       let range = validatorInfo?.formula ?? "";

//       if (range) {
//         range = range.replaceAll("=", "").replaceAll("$", "");
//         if (!range.includes("!")) {
//           let sheet = sheetName.includes(" ")
//             ? "'" + sheetName + "'"
//             : sheetName;
//           range = sheet + "!" + range;
//         }
//         if (range.length > 2)
//           ranges.push({
//             type: "dropdown",
//             name: validation.ranges,
//             range: range,
//           });
//       }
//     }
//   });
//   return ranges;
// }

export function jsonExcelOptimize(json) {
  if (!json) return;
  try {
    let sheets = json.sheets;
    Object.keys(sheets).forEach((sheetItem, index) => {
      let sheet = sheets[sheetItem];
      if (sheet.shapes) {
        sheet.shapes = sheet.shapes.filter(
          (item) => [1, 8].includes(item?.shapeType), // what is with 7 = button
        );
      }
    });
    return json;
  } catch (error) {
    console.log("ERROR jsonExcelOptimize", error);
  }
}

export function getRangeAsOffset(address) {
  if (!address || address.length < 2) return;
  // protect against max cells in Excel
  if (address.includes("A1:XFD1048576")) {
    address = address.replace("A1:XFD1048576", "A1:Z1000");
  }

  try {
    const sheetNameSeparatorIndex = address.indexOf("!");
    let sheetName =
      sheetNameSeparatorIndex > -1
        ? address.substring(0, sheetNameSeparatorIndex)
        : "";
    // calculate offset
    let offsetAddress = address
      .replace(sheetName + "!", "")
      .replaceAll("'", "")
      .replaceAll("$", "");

    let separatorIndex = offsetAddress.indexOf(":");

    const offsetFromString = offsetAddress.substring(0, separatorIndex);
    const offsetToString = offsetAddress.substring(separatorIndex + 1);
    if (offsetFromString === offsetToString) separatorIndex = -1;

    let type = separatorIndex === -1 ? "cell" : "range";
    sheetName = sheetName.replaceAll("'", "");

    if (type === "range") {
      let offsetFrom = getCartesianCoords(offsetFromString);
      offsetFrom.col = offsetFrom.col - 1;
      offsetFrom.row = offsetFrom.row - 1;
      let offsetTo = getCartesianCoords(offsetToString);
      offsetTo.col = offsetTo.col - 1;
      offsetTo.row = offsetTo.row - 1;
      return {
        sheetName: sheetName,
        sheetIndex: -1,
        type: type,
        rowFrom: offsetFrom.row,
        colFrom: offsetFrom.col,
        rowTo: offsetTo.row,
        colTo: offsetTo.col,
      };
    } else {
      let offset = getCartesianCoords(offsetToString);
      offset.col = offset.col - 1;
      offset.row = offset.row - 1;
      return {
        sheetName: sheetName,
        sheetIndex: -1,
        type: type,
        row: offset.row,
        col: offset.col,
      };
    }
  } catch (error) {
    console.log("ERROR getRangeAsOffset", error, address);
  }
}

var CAPITAL_A = 65;

export function getExcelColName(col, offset) {
  var colStr = "";
  while (col > 0) {
    colStr = toChar((col + offset - 1) % 26) + colStr;
    col = Math.floor((col - 1) / 26);
  }
  return colStr;
}

// Helper function to convert Excel column name to number (reverse of getExcelColName)
function excelColNameToNumber(colName, offset) {
  let result = 0;
  for (let i = 0; i < colName.length; i++) {
    result = result * 26 + (colName.charCodeAt(i) - 65 + offset);
  }
  return result;
}

export function getExcelColNames(colList, offset) {
  if (!colList) return "";

  let colStr = "";
  let list = [];
  colList.forEach((col, index) => {
    let colStart = col?.start + 1;
    let colEnd = col?.end + 1;

    let colStartName = getExcelColName(colStart, offset);
    let colEndName = getExcelColName(colEnd, offset);
    if (colStartName === colEndName) {
      list.push(colStartName);
    } else {
      list.push(colStartName + "-" + colEndName);
    }
  });
  colStr = list.join(",");
  return colStr;
}

export function parseExcelColNames(csvString, offset = 1) {
  if (!csvString) return [];

  // Split by comma and trim whitespace
  const ranges = csvString.split(",").map((range) => range.trim());

  return ranges.map((range) => {
    // Check if it's a range (contains hyphen) or single column
    if (range.includes("-")) {
      const [startCol, endCol] = range.split("-").map((col) => col.trim());
      const startIndex = excelColNameToNumber(startCol, offset) - 1; // Convert to 0-based
      const endIndex = excelColNameToNumber(endCol, offset) - 1; // Convert to 0-based

      return {
        id: nanoid(),
        selected: "column",
        start: startIndex,
        end: endIndex,
      };
    } else {
      // Single column
      const colIndex = excelColNameToNumber(range, offset) - 1; // Convert to 0-based
      return {
        id: nanoid(),
        selected: "column",
        start: colIndex,
        end: colIndex,
      };
    }
  });
}

export function getExcelRowNames(rowList, offset) {
  if (!rowList) return "";

  let rowStr = "";
  let list = [];
  rowList.forEach((row, index) => {
    let rowStart = row?.start + 1;
    let rowEnd = row?.end + 1;

    let rowStartName = rowStart - offset;
    let rowEndName = rowEnd - offset;
    if (rowStartName === rowEndName) {
      list.push(rowStartName);
    } else {
      list.push(rowStartName + "-" + rowEndName);
    }
  });
  rowStr = list.join(",");
  return rowStr;
}

// Reverse function: converts row CSV string back to array format
export function parseExcelRowNames(csvString, offset = 1) {
  if (!csvString || csvString.trim() === "") return [];
  
  // Split by comma and trim whitespace
  const ranges = csvString.split(',').map(range => range.trim());
  
  return ranges.map(range => {
    // Check if it's a range (contains hyphen) or single row
    if (range.includes('-')) {
      const [startRow, endRow] = range.split('-').map(row => parseInt(row.trim(), 10));
      const startIndex = startRow + offset - 1; // Convert back to 0-based with offset
      const endIndex = endRow + offset - 1;     // Convert back to 0-based with offset
      
      return {
        id: nanoid(),
        selected: "row",
        start: startIndex,
        end: endIndex
      };
    } else {
      // Single row
      const rowNum = parseInt(range.trim(), 10);
      const rowIndex = rowNum + offset - 1; // Convert back to 0-based with offset
      return {
        id: nanoid(),
        selected: "row",
        start: rowIndex,
        end: rowIndex
      };
    }
  });
}

export function getExcelCoords(row, col) {
  var colStr = "";
  while (col > 0) {
    colStr = toChar((col - 1) % 26) + colStr;
    col = Math.floor((col - 1) / 26);
  }
  return colStr + row;
}

function toChar(n) {
  return String.fromCharCode(CAPITAL_A + n);
}

// The inverse is also quite simple:

export function getCartesianCoords(excelCoords, offset) {
  if (!excelCoords) return { row: 0, col: 0 };
  let address = excelCoords;
  if (excelCoords.includes("!")) {
    address = getLocalCellNameFromAddressNoDollar(excelCoords);
  }
  let coords = address.toUpperCase();
  var row = parseInt(coords.replace(/^[A-Z]+/, ""));
  var colChars = coords.replace(/\d+$/, "").split("").reverse();
  var col = 0;
  var multiplier = 1;
  while (colChars.length) {
    col += toBase26Ish(colChars.shift()) * multiplier;
    multiplier *= 26;
  }
  if (offset) {
    col = col - offset.col - 1;
    row = row - offset.row - 1;
  }
  return { row, col };
}

function toBase26Ish(c) {
  return c.charCodeAt(0) - CAPITAL_A + 1;
}

export function getCellFormatFromExcelFormat(cellFormat) {
  if (!is.string(cellFormat)) return "";

  if (cellFormat === "General") return "";

  let newFormat = cellFormat.replaceAll('"', "'");
  if (cellFormat.includes("##0")) newFormat = "0,0"; //"#,##0";
  if (cellFormat.includes("##0.0")) newFormat = "0,0.0"; //"#,##0.0";
  if (cellFormat.includes("##0.00")) newFormat = "0,0.00"; //"#,##0.00";

  if (cellFormat.includes("%")) newFormat = "0%";
  if (cellFormat.includes("0.0%")) newFormat = "0.0%";
  if (cellFormat.includes("0.00%")) newFormat = "0.00%";

  if (cellFormat.includes("y")) newFormat = "dd.MM.yyyy";
  if (cellFormat.includes("mmm-yy")) newFormat = "MMM-yy";
  if (cellFormat === "mmmm") newFormat = "MMMM";
  if (cellFormat === "mmm") newFormat = "MMM";
  if (cellFormat === "dddd") newFormat = "EEEE";
  if (cellFormat === "ddd") newFormat = "EEE";

  // console.log("cellFormat", cellFormat, newFormat);
  return newFormat;
}

export function getCellTypeFromExcelCellFormat(cellFormat) {
  let cellType = "general";
  let dataType = "numeric";

  // check for DATATYPE
  if (
    is.string(cellFormat) &&
    cellFormat.length > 0 &&
    cellFormat !== "General"
  ) {
    const checkCellFormat = cellFormat.toLocaleLowerCase();
    if (String(checkCellFormat).includes("#")) {
      cellType = "number";
      dataType = "numeric";
    } else if (
      (checkCellFormat.includes("y") ||
        checkCellFormat.includes("m") ||
        checkCellFormat.includes("d")) &&
      !isNaN(Date.parse(checkCellFormat))
    ) {
      dataType = "date";
      cellType = "date";
    } else if (checkCellFormat.includes(":")) {
      dataType = "time";
      cellType = "time";
    }
    if (checkCellFormat.includes("%")) {
      cellType = "percentage";
      dataType = "numeric";
    }
  }

  return { cellType, dataType };
}

// export function getCellPatternFromExcelNumericFormat(cellFormat) {
//   const normalizedFormat = cellFormat?.replace("##0,0", "##0.0") ?? "";
//   const isPercentage = cellFormat?.includes("%");
//   let mantissa = 0;
//   if (!isPercentage) {
//     if (normalizedFormat.includes("0.0")) mantissa = 1; //"#,##0.0";
//     if (normalizedFormat.includes("0.00")) mantissa = 2; //"#,##0.00";
//     if (normalizedFormat.includes("0.000")) mantissa = 3; //"#,##0.00";
//     return {
//       thousandSeparated: true,
//       mantissa: mantissa,
//     };
//   }

//   if (cellFormat.includes("%")) mantissa = 0;
//   if (cellFormat.includes("0.0%")) mantissa = 1;
//   if (cellFormat.includes("0.00%")) mantissa = 2;
//   if (cellFormat.includes("0.000%")) mantissa = 3;
//   return {
//     thousandSeparated: true,
//     spaceSeparated: true,
//     output: "percent",
//     mantissa: mantissa,
//   };
// }

export function removeSheetProperties(sheet, removeSecondaryData = true) {
  if (!sheet) return;

  if (sheet.hasOwnProperty("data") && removeSecondaryData) delete sheet.data;
  if (sheet.hasOwnProperty("pivotTables")) delete sheet.pivotTables;
  if (sheet.hasOwnProperty("selections")) delete sheet.selections;
  if (sheet.hasOwnProperty("rowFilter")) delete sheet.rowFilter;
  if (sheet.hasOwnProperty("tables") && removeSecondaryData)
    delete sheet.tables;
  if (sheet.hasOwnProperty("charts")) delete sheet.charts;
  if (sheet.hasOwnProperty("printInfo")) delete sheet.printInfo;
  // if (sheet.hasOwnProperty("columns") && removeSecondaryData)
  //   delete sheet.columns;
  // if (sheet.hasOwnProperty("rows") && removeSecondaryData) delete sheet.rows;
  if (sheet.hasOwnProperty("theme")) delete sheet.theme;
  if (sheet.hasOwnProperty("names") && removeSecondaryData) delete sheet.names;
  if (sheet.hasOwnProperty("shapes")) delete sheet.shapes;
  if (sheet.hasOwnProperty("validations")) sheet.validations = [];
  // if (sheet.hasOwnProperty("sharedFormulas")) sheet.sharedFormulas = {};
  if (sheet.hasOwnProperty("defaults")) sheet.defaults = {};
  if (sheet.hasOwnProperty("spans")) sheet.spans = [];
  if (sheet.hasOwnProperty("comments")) sheet.comments = [];

  // if (sheet.hasOwnProperty("data")) sheet.data = {};
  // if (sheet.hasOwnProperty("pivotTables")) sheet.pivotTables = [];
  // if (sheet.hasOwnProperty("tables")) sheet.tables = [];
  // if (sheet.hasOwnProperty("names")) sheet.names = [];
  // if (sheet.hasOwnProperty("sharedFormulas")) sheet.sharedFormulas = {};
  // if (sheet.hasOwnProperty("selections")) sheet.selections = {};
  // if (sheet.hasOwnProperty("rowFilter")) sheet.rowFilter = {};
  // if (sheet.hasOwnProperty("charts")) sheet.charts = [];
  // if (sheet.hasOwnProperty("printInfo")) sheet.printInfo = {};
  // if (sheet.hasOwnProperty("columns")) sheet.columns = [];
  // if (sheet.hasOwnProperty("rows")) sheet.rows = [];
  // if (sheet.hasOwnProperty("theme")) sheet.theme = {};
  // if (sheet.hasOwnProperty("shapes")) sheet.shapes = [];
  // if (sheet.hasOwnProperty("floatingObjects")) sheet.floatingObjects = [];
  // if (sheet.hasOwnProperty("validations")) sheet.validations = [];
  // if (sheet.hasOwnProperty("defaults")) sheet.defaults = {};
  // if (sheet.hasOwnProperty("conditionalFormats"))
  //   sheet.conditionalFormats = {};
  // if (sheet.hasOwnProperty("spans")) sheet.spans = [];
  // if (sheet.hasOwnProperty("comments")) sheet.comments = [];
}
